module.exports = __webpack_public_path__ + "media/images/smart_phone/login/202001/logo_02-f125fc2080225cc5bb3dca5a8afe80e6.png";